<template>
  <Navbar :title="''" :rightBtn="true"></Navbar>
  <div class="content-bg">
    <img class="img" src="@/assets/images/bg/bg_8@2x.svg" />
    <div class="header">
      <!-- <div class="avatar-box flex" :class="{ 'vip-content': isVipShow }">
        <div class="flex-avatar">
          <div class="avatar-img-b">
            <img class="avatar-img" :src="userInfo.avatar" alt="" v-if="userInfo.avatar" />
            <img class="avatar-img" src="@/assets/images/avatar.jpg" alt="" v-else />
          </div>
          <img class="vip-img" src="@/assets/images/setup/icon_vip_1@2x.png" alt="" v-if="isVip" />
          <img class="vip-img" src="@/assets/images/setup/icon_vip_2@2x.png" alt="" v-else />
        </div>
        <div class="flex-item flex user-info" @click="toVip">
          <div class="flex-item">
            <div class="title_1" v-if="companyInfo && companyInfo.name">{{ companyInfo.name }}</div>
            <div class="tag-box">
              <div class="tag-item tag-reg-type" v-if="companyInfo.registerData && companyInfo.registerData.regType"><div>{{ companyInfo.registerData.regType}}</div></div>
              <span class="tag-item tag-item-vip" v-if="isVipShow">VIP</span>
              <span class="tag-item tag-item-vip-no" v-if="!isVipShow">未开通VIP</span>
            </div>
            <div class="vip-date" v-if="isVipShow">
              VIP有效期至:{{ userInfo.expiration_time }}
            </div>
            <div class="vip_no_flag_box" v-if="!isVipShow">
              <span>获取VIP，享受六大权益</span>
            </div> 
          </div>
        </div>
      </div> -->

       <div class="avatar-box flex" :class="{ 'vip-content': isVip }">
        <div class="flex-avatar">
          <div class="avatar-img-b">
            <img class="avatar-img" :src="userInfo.avatar" alt="" v-if="userInfo.avatar" />
            <img class="avatar-img" src="@/assets/images/avatar.jpg" alt="" v-else />
          </div>
          <!--<img class="vip-img" src="@/assets/images/setup/icon_vip_1@2x.png" alt="" v-if="isVip" />-->
          <!--<img class="vip-img" src="@/assets/images/setup/icon_vip_2@2x.png" alt="" v-else />-->
        </div>
        <div class="flex-item flex user-info" @click="toVip">
          <div class="flex-item">
          <div class="head-title">请关联企业信息</div>
            <div class="title_1" v-if="userInfo.company && userInfo.company.name"></div>
            <!--<div class="tag-box">-->
              <!--<span v-if="isVip">-->
                <!--<span class="tag-item tag-item-vip">VIP</span>-->
                <!--<span class="vip-date">有效期至: {{ userInfo.expiration_time_show }}</span>  -->
              <!--</span>-->
              <!--<span v-if="!isVip">-->
                <!--<span class="color_1">会员状态</span><span class="tag-item tag-item-vip-no">待激活</span>-->
              <!--</span>-->
            <!--</div>-->
            <div class="update-box">
              <van-button class="btn-update" @click.stop="goSearch">添加企业申报数据</van-button>提高匹配准确度
            </div> 
          </div>
        </div>
      </div>

      <div class="grid-box match-detail">
        <div class="grid-item">
          <div class="grid-item-content grid-item-content-d">
            <div class="grid-item-content-title">
              <img class="nav-img" src="@/assets/images/match/icon_1@2x.png" />
              成立日期
            </div>
            <div class="grid-name">待关联</div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-item-content grid-item-content-l">
            <div class="grid-item-content-title">
              <img class="nav-img" src="@/assets/images/match/icon_2@2x.png" />
              法定代表人
            </div>
            <div class="grid-name">待关联</div>
          </div>
        </div>
        <div class="grid-item">
          <div class="grid-item-content grid-item-content-r">
            <div class="grid-item-content-title">
              <img class="nav-img" src="@/assets/images/match/icon_3@2x.png" />
              注册资本
            </div>
            <div class="grid-name">待关联</div>
          </div>
        </div>
        <div class="grid-item" style="flex-basis: 99%;margin-top: 15px;">
          <div class="grid-item-content">
            <div class="grid-item-content-title">
              <img class="nav-img" src="@/assets/images/match/icon_4@2x.png" />
              注册地址
            </div>
            <div class="grid-name" >待关联</div>
          </div>
        </div>
      </div>
    </div>
  </div>

<!--
    <coupon-ad></coupon-ad>
-->

  <div class="warpper-b">
    
    <div class="match-box"  v-if="!emptyShow">
          <div class="match-head">
              <div class="match-quick-title">智能匹配</div>
              <div class="match-quick-title">立项记录</div>
          </div>
          <div style="display:flex;justify-content: space-between;height:auto">
                <div  style="width:100%;height:auto;display:flex;flex-wrap: wrap;align-content: space-between;">
                  <div class="match-quick-box" v-if="!emptyShow" @click="goDetailFoMatch1">
                    <div class="match-quick-box-head"> 资金申报</div>
                    <div class="match-quick-box-num">当前可申报的政策<span class="num_total">{{declare_type2}}</span>条</div>
                    <div class="match-quick-box-text">预估奖励（万元）</div>
                    <div style="display:flex;">
                      <div class="num" style="flex:1;">{{recomend.moneyScope}}</div>
                      <div class="match-quick-box-icon3">查看详情 <img src="../../assets/icons/Union.svg" alt=""></div>
                    </div>
                  </div>
                  <div class="match-quick-box" v-if="!emptyShow" @click="goDetailFoMatch2" style="height:auto;">
                    <div class="match-quick-box-head" style="display:flex;"> 
                      <div style="flex:1;">资质办理</div>
                      <div class="match-quick-box-icon3">查看详情 <img src="../../assets/icons/Union.svg" alt=""></div>
                    </div>
                    <div class="match-quick-box-num">当前可办理的资质<span class="num_total">{{declare_type1}}</span>条</div>
                  </div>
                </div>
                <div class="match-quick-box1" style="height:auto" v-if="!emptyShow" @click="toDetail">
                  <div class="match-quick-name">{{ recomend.title }}</div>
                  <div class="match-quick-txt" ><span>共有<span class="num_total">{{lxListTotal}}</span>个立项记录</span> </div>
                  <div class="match-quick-content1">
                    <div> <span>政策名称：</span><span>{{lxcxInfo._PolicyName}}</span> </div>
                    <div> <span>所属口径：</span><span>{{lxcxInfo._Source}}</span> </div>
                    <div> <span>立项时间：</span><span>{{lxcxInfo._ApprovalDate}}</span> </div>
                    <div> <span>立项金额：</span><span style="color:#FF7319;">{{lxcxInfo._ApprovalAmount}}万元</span> </div>
                  </div>
                  <div class="lxcx-more" style="display:flex;">
                    <div class="match-quick-box-icon3" @click="toDetail" style="flex:1;"> 查看更多<img src="../../assets/icons/Union.svg" alt=""></div>
                    <div class="img-box"><img src="../../assets/icons/Maskgroup.svg" alt="" class="img"></div>
                  </div>
                </div>
          </div>
        
    </div>
    <van-sticky>
    <div style="background:#fff;">
    <van-tabs ref="tabs" v-model:active="activeTabs" @click-tab="changeTabs" style="margin-bottom:10px;">
      <van-tab
        v-for="item in tabs"
        :key="item"
        :title="item.title"
        :name="item.id"
      >
      </van-tab>
    </van-tabs>
    <div class="match-container-search">
        <input type="text" placeholder="请输入搜索关键词" v-model="formSearch.keywords" />
        <div class="btn" @click.stop="clickSearch" style="width: 60px;">
          <img src="@/assets/images/vector@2x.png" alt="">
        </div>
      </div>
    <div class="serch" style="padding: 10px 0;width:75%;margin-left:10%;">  
      <div class="flex-item">
      <span class="serch-item" :class="{'serch-item-active':show3}" @click="showPopup3">请选择行政级别</span>
      </div>
      <div class="flex-item">
        <span class="serch-item" :class="{'serch-item-active':show2}" @click="showPopup2">请选择发文部门</span>
      </div> 
      <div class="flex-item">
        <span class="serch-item" :class="{'serch-item-active':showSort}" @click="showPopupSort">排序</span>
      </div> 
    </div>
    </div> 
    </van-sticky>
    <van-empty description="暂无数据" v-show="emptyShow" />
    <van-list v-model:loading="loading" :finished="finished" finished-text="没有更多了"  v-if="!emptyShow">
      <div class="policy-file-item" v-for="(record,index) in list" :key="record" @click="goDetail(record)">
        <div class="policy-file-item-content" :class="{ 'notice-item-novip': index == list.length - 1 &&!certificationFlag}">
          <div class="flex">
            <div class="flex-item">
              <div class="policy-file-item-title">
                <span class="level" v-if="record.level==0">国</span>
                <span class="level" v-if="record.level==1">省</span>
                <span class="level" v-if="record.level==2">市</span>
                <span class="level" v-if="record.level==3">区县</span>
                <span class="level" v-if="record.level>3">其他</span>
                {{ record.title }}
              </div>
              <div class="policy-file-item-tags with-row-gap">
                <span class="tag" v-for="(item, indexT) in record.policyTopic" :key="item" :class="'tag_' + indexT">
                  {{ item }}
                </span>
              </div>
            </div>
            <div class="btn-boxs">
              <!-- <div class="favorite" >
                收藏
                <van-switch class="switch" v-model="record.favoriteValue" @click.stop="clickFavorite(record)" active-color="#FB8729" inactive-color="#F4E3D8" size="18px" />
              </div> -->
<!--                 <van-button-->
<!--                  class="btn-favorite"-->
<!--                  v-if="!record.favoriteValue"-->
<!--                 @click.stop="clickFavorite(record,true)"-->
<!--                >-->
<!--                  <img-->
<!--                    class="icon-favorite"-->
<!--                    src="@/assets/images/icon_favorite_1@2x.png"-->
<!--                  />-->
<!--                  收藏-->
<!--                </van-button>-->
<!--                <van-button-->
<!--                  class="btn-favorite btn-favorite-active"-->
<!--                  v-if="record.favoriteValue"-->
<!--                 @click.stop="clickFavorite(record,false)"-->
<!--                >-->
<!--                  <img-->
<!--                    class="icon-favorite"-->
<!--                    src="@/assets/images/icon_favorite_2@2x.png"-->
<!--                  />-->
<!--                  已收藏-->
<!--                </van-button>-->
              <div>
                <van-button class="btn-de" type="primary" v-if="record.statusView == '1'" @click.stop="declare(record)">申报</van-button>
                <van-button class="declare-btn" type="primary" plain hairline v-else-if="record.statusView == '2'">
                  未开始
                </van-button>
                <van-button class="btn-de" type="primary" plain hairline v-else-if="record.statusView == '0'">已结束</van-button>
              </div>
            </div>
          </div>
        
             <div class="policy-file-item-footer" style="border:0;padding: 0 0 3px 0;">
            <div class="flex-item" style="flex: 1;display:flex;">
              <div style="margin-right:25px">
                 <div class="flex-item company" style="color:#3E8776 " v-if="record.declare && record.declare.start_time&& record.declare.start_time!=record.declare.end_time ">
                  开始时间：{{record.declare.start_time.slice(0,10)}}
              </div>
              <div class="flex-item"  style="margin-right:43px;color:#DB4C1A" v-if="record.declare && record.declare.end_time&& record.declare.start_time!=record.declare.end_time">
                截止日期： {{record.declare.end_time.slice(0,10)}}
              </div>
              <div class="flex-item company" style="margin-right:43px" v-if="record.declare && record.declare.end_time&& record.declare.start_time==record.declare.end_time">
                开始及结束时间： {{record.declare.end_time.slice(0,10)}}
              </div>
              <div class="policy-file-item-footer" style="border:0;padding: 0 0 3px 0;" >
                  <div class="flex-item company" v-if="record.time">
                      发布时间：{{record.time.slice(0,10)}}
                  </div>
              </div>
              </div>
              <div >
                <div class="flex-item company">
                  阅读量:{{ record.click_num }}
                </div>

                <div class="flex-item" >
                  收藏量:{{ record.favorite_num }}
                </div>
              </div>
            </div>
          </div>
         
          <div class="policy-content" v-if="record.content">
            <div>{{ record.content }}</div>
          </div>
<!--          <div class="policy-file-item-result" v-if="this.activeTabs == 'declare'">-->

<!--            <div class="flex-item result-b">-->
<!--              匹配评分<span class="num-r color-1">{{ record.matchingDegree }}分</span>-->
<!--            </div>-->

<!--            <div class="flex-item" style="margin-left: 10px;" v-if="record.moneyScope">-->
<!--              奖励<span class="num-p color-1">{{ record.moneyScope }}</span>万元-->
<!--            </div>-->
<!--          </div>-->


        </div>
      
        <div class="novip-box" v-if="!certificationFlag && index == list.length - 1">
            <div class="flex-item">
                <div>以上为展示政策信息 </div>
                   <div> 关联企业后才能推荐相关政策</div>
                <van-button class="btn" @click.stop="goMore">立即关联</van-button>
            </div>
        </div>
      </div>
    </van-list>
  </div>

<!--  <div class="float-action" v-if="!emptyShow && list.length">-->
<!--    <div class="flex-item">-->
<!--      <van-button class="btn" type="danger" @click="declareAll">-->
<!--        <img src="@/assets/images/match/btn_declare@2x.png">-->
<!--        一键申报-->
<!--        </van-button>-->
<!--    </div>-->
<!--  </div>-->


  <div v-if="declareShow">
    <declare-model :show="declareShow" :list="declareList" @declareSelected="declareSelected"
      @closeDeclare="closeDeclare"></declare-model>
  </div>

  <van-popup v-model:show="show2" round position="bottom" >
        <div class="boxs">
                <p class='title' style="padding-top:10px;">请选择发文部门</p>
                <div style=" height: 200px;overflow:auto; " >
                  <div class="field-ul">
                      <div class="flex-tag-select-container">
                          <div v-for="(item, i) in fieldList" :key="i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItem(item)">
                              {{ item.dispatch_name }}
                          </div>
                      </div>
                  </div>
                </div> 
                <div style="margin: 22px 55px;text-align:center;">
                <van-button  @click="roundbtn2" class="roundbtn" round type="primary" >确定</van-button>
              </div>
            </div>
    </van-popup>
    <van-popup v-model:show="show3" round position="bottom" >
      <div class="boxs">
                <p class='title' style="padding:10px 0;">请选择行政级别</p>
                <div style=" height: 100px;overflow:auto; " >
                  <div class="field-ul">
                      <div class="flex-tag-select-container" style="grid-template-columns:1fr 1fr 1fr 1fr;">
                          <div v-for="(item, i) in levelList" :key="i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItemLevel(item)">
                              {{ item.name }}
                          </div>
                      </div>
                  </div>
                </div> 
                <div style="margin: 22px 55px;text-align:center;">
                <van-button  @click="clickLevel" class="roundbtn" round type="primary" >确定</van-button>
              </div>
            </div>
    </van-popup>
    <van-popup v-model:show="showSort" round position="bottom" >
      <div class="boxs">
                <p class='title' style="padding:10px 0;">请选择排序方式</p>
                <div style=" height: 100px;overflow:auto; " >
                  <div class="field-ul">
                      <div class="flex-tag-select-container" style="grid-template-columns:1fr 1fr 1fr 1fr;">
                          <div v-for="(item, i) in sortList" :key="i" class="flex-tag-select-item"
                              :class="{ 'selected': item.checked }" @click="() => toggleItemSort(item)">
                              {{ item.name }}
                          </div>
                      </div>
                  </div>
                </div> 
                <div style="margin: 22px 55px;text-align:center;">
                <van-button  @click="roundbtnSort" class="roundbtn" round type="primary" >确定</van-button>
              </div>
            </div>
    </van-popup>

    <van-dialog
    class="service-box"
    v-model:show="showDialog"
    show-cancel-button
    :before-close="beforeClose"
  >
    <div class="title">确认服务信息</div>
    <div class="content">
      <div class="box">
        <div class="flex">
          <div class="label">服务商名称</div>
          <div class="flex-item">{{ serviceInfo.provider_name }}</div>
        </div>
        <div class="flex">
          <div class="label">服务类别</div>
          <div class="flex-item">{{ serviceInfo.type }}</div>
        </div>
      </div>
      <div class="box">
        <div class="flex">
          <div class="label">企业名称</div>
          <div class="flex-item">{{ serviceInfo.company_name }}</div>
        </div>
        <div class="flex">
          <div class="label">姓名</div>
          <div class="flex-item">{{ serviceInfo.user_name }}</div>
        </div>
        <div class="flex">
          <div class="label">手机号码</div>
          <div class="flex-item">{{ serviceInfo.phone }}</div>
        </div>
      </div>
    </div>
  </van-dialog>

    <backTop :top="900"></backTop>
</template>
<script>

import { getPolicyByTags, noVip,getServiceProviderList,getDispatchv3, queryUserById, getPolicyByTagsV3,getCompanySearchInfoV2,addFavoritev3,cancelFavoritev3,lxcxLists,savePhoneAndCompanyName } from "@/api/home"
import Select from '@/components/Select.vue'
import SearchDetail from '@/components/SearchDetail.vue'
import Dates from '@/components/Date.vue'
import Area from '@/components/Area.vue'
import Navbar from '@/components/Navbar'
import DeclareModel from '@/components/DeclareModel'
import { clickUrl, clickUrlToPhone, goCodeFirm } from '@/utils'
import { mapState } from 'vuex'
import { getUserInfo, getUserId } from '@/utils/storage'
import store from '@/store';
import CouponAd from '../../components/CouponAd.vue'
import moment from 'moment'
import backTop from '@/components/BackTop.vue'
export default {
  name: 'ResultCopy',
  data() {

    return {
      list: [],
      time:'',
      favorite: false,
      loading: false,
      finished: false,
      declareShow: false,
      formCompany: {},
      declareInfo: {},
      queryParams: {},
      emptyShow: false,
      userId: '',
      userInfo: {},
      isVip: true,
      companyInfo: {},
      recomend: {},
      totalList: 0,
      type:1,
      show2:false,
      show3:false,
      fieldList: [],
      lxcxInfo: {},
      lxListTotal: 0,
      formSearch: {
        keywords: '',
        dispatch_name: '',
        level: '',//发文级别
        sort: '',
      },
      levelList: [
        {name:"国家",id:'0',checked:false},
        {name:"省",id:'1',checked:false},
        {name:"市",id:'2',checked:false},
        {name:"区县",id:'3',checked:false},
      ],
      end_time: "2021-05-04 15:20:00",
      start_time: "2021-05-04 15:20:00",
      showSort: false,
      sortList: [
        {name:"匹配分值",id:'matchingDegree',checked:false},
        {name:"奖励金额",id:'moneyScope',checked:false},
        {name:"发布时间",id:'time',checked:false},
      ],
      showDialog: false,
      serviceInfo: {},
      orderInfo: {},
      certification_flag: 1,
      activeTabs: "declare",
      tabs: [
        { title: "申报通知", id: "declare" },
        { title: "立项公示", id: "policy" },
        { title: "其他政策", id: "notify" },
      ],
    }
  },
  components: { Select, SearchDetail, Dates, Area, Navbar, DeclareModel, CouponAd,backTop },
  computed: {
    isVipShow(){
      return this.userInfo.company && this.companyInfo && this.userInfo.company.name == this.companyInfo.name && this.isVip 
    }
  },

  mounted() {
    this.activeTabs = "declare"
    // this.queryParams = this.$route.query.search ? JSON.parse(this.$route.query.search) : {}
    // console.log(206,this.queryParams)
    // this.init()
    this.getUser()
    // this.getData()
     this.$refs.tabs.resize()
  },
  watch: {},
  methods: {
    moment,
      goMore() {
         clickUrl('/enterprise_match')
      },
    toDetail() {
      clickUrl('/ai/project_query')
    },
    showPopup2(){
      // this.show2 = !this.show2
      // if (this.fieldList.length) {
      //   return false
      // }
      this.getbumen()
    },
     async getbumen (){
       console.log(this.activeTabs);
       try {
        let params = { type: 3 }
          if (this.formSearch.level != '') {
            params.level = this.formSearch.level
          }
         let res = await getDispatchv3(params)
         this.fieldList = res.result.map((item) => {
          return {
            ...item,
            checked: this.formSearch.dispatch_name && item.dispatch_name == this.formSearch.dispatch_name ? true : false,
          }
        })
        this.show2 = true
       } catch {
        
       }
    
    },
    roundbtn2(){
      var arr = this.fieldList.filter(o=> o.checked)
      this.formSearch.dispatch_name = arr.length ? arr[0].dispatch_name : ''
      this.getData()
      // this.showPopup2()
      this.show2 = false
    },
    showPopup3(){
      this.show3=!this.show3
    },
    toggleItem(val) {
      this.fieldList = this.fieldList.map((item) => {
        return {
          ...item,
          checked: item.dispatch_name == val.dispatch_name ? !item.checked : false,
        };
      });
    },
    clickLevel() {
      var arr = this.levelList.filter(o=> o.checked)
      this.formSearch.level = arr.length ? arr[0].id : ''
      this.formSearch.dispatch_name = ''
      this.getData()
      this.showPopup3()
    },
     init() {
    this.getDeclareList()
    },
    async getUser() {
      try {
        let res = await queryUserById()
        this.userInfo = res.result || {}
        this.userId = res.result.id
        let e_time = res.result.expiration_time ? res.result.expiration_time.replace(/-/g, '/') : null
        let expirationTime = new Date(e_time).getTime()
        let time = new Date().getTime()
        this.certification_flag = res.result.certification_flag
        this.isVip = time < expirationTime ? true : false
        this.userInfo.expiration_time_show = moment(res.result.expiration_time).format("YYYY年MM月DD日")
        goCodeFirm(this.userInfo)
      } catch (res) {
        if (res.status == '2') {
          goCodeFirm(this.userInfo)
        }
       }
      this.getData()
    },
    async getLxcx() {
       let params = {
          company: this.userInfo.company.name,
          page: 1,
          pageSize: 20,
      }
      try {
        let res = await lxcxLists(params)     
        
        if (res.result.result == 'fail') {
          this.lxcxInfo = 0
          this.lxListTotal = 0
          return false
        }
        this.lxcxInfo = res.result.tablerecord[0]
        this.lxListTotal = Number(res.result.recordcount) || 0
      } catch {
                  
      }
                
    },
    async getCompanySearchInfo(){
      try{
        let res = await getCompanySearchInfoV2({name:this.queryParams.name})
        this.companyInfo = res.result || {}
      } catch{}
    },
    async getDeclareList() {
      let res = await getServiceProviderList({ type: 'policy_declare_flag' })
      this.declareList = res.result.data ? res.result.data : []
    },

    goDetail(item) {
      // clickUrl('/detail',{id:item.id,policyId:item.id,title:'政策内容',btnType:'1',company:JSON.stringify(item.company)})
      clickUrl('/article/detail', { id: item.declare_id,articleId:item.id, btnType: '1',matchingDegree: item.matchingDegree ,matchType:1,declare_id: item.declare_id})
    },
    clickSearch() {
      this.getData()
    },
    async getData() {
      this.loading = true
      let params = Object.assign({},this.queryParams)
      let { keywords, dispatch_name, level } = this.formSearch
      if (keywords) {
        params.keywords = keywords
      }
      if (dispatch_name) {
        params.dispatch_name = dispatch_name
      }
      if (level != '') {
        params.level = level
      }
      // params.match_type = 1
      if (this.activeTabs == "declare") {
        params.type = 1
        params.match_type = 1
      } else if (this.activeTabs == "policy") {
        params.type = 2
        params.match_type = 0
      } else if (this.activeTabs == "notify") {
        params.type = 0
        params.match_type = 0
      }

      if(this.certification_flag==0){

        try {
          let res = await noVip(params)
          if (res.result.recomend) {
            this.recomend = res.result.recomend || {}
            this.recomend.moneyScope = this.getMoneyScope(res.result.recomend.money_scope_max, res.result.recomend.money_scope_min) || ''
          }
          console.log(res);
          let list = res.result.map((item) => {
            let arr = []
            if (item.dispatch_name) arr.push(item.dispatch_name)
            // arr.push('资金扶持')
            if(item.declare_type==1){
              arr.push('资质办理')
            }else if(item.declare_type==0){
              arr.push('资金申报')
            }
            if(item.favorite ?true :false){
              this.type =1
            }else{
              this.type=2
            }
            item.statusView = -1
            if (item.declare) {
              let nowTime = new Date().getTime()
              let startTime = item.declare && item.declare.start_time ? moment(item.declare.start_time).toDate().getTime() : ''
              let endTime = item.declare && item.declare.end_time ? moment(item.declare.end_time).toDate().getTime() : ''

              if (endTime && nowTime >= endTime) {
                item.statusView = 0
              } else if (startTime && nowTime < startTime) {
                item.statusView = 2
              } else if (startTime && nowTime >= startTime) {
                item.statusView = 1
              }
            }
            return {
              ...item,
              policyTopic: arr,
              content: item.description ? this.getText(item.description) : '',
              favoriteValue: item.favorite ? true : false,
              matchingDegree: this.getNum(item.matching_degree),
              moneyScope: item.declare && this.getMoneyScope(item.declare.money_scope_max, item.declare.money_scope_min),
              statusView: item.statusView
            }
          }) || []
          this.formSearch.sort = 'sort'
          let list_new = this.sortFn(list,'sort')
          list_new = list
          // if (!this.isVip) {
          //   list_new = list.slice(0,6)
          // }else{
          //   list_new = list
          // console.log( list_new);
          // }
          this.list = list_new
          console.log(this.list);
          this.totalList = res.result.count || 0
          this.finished = this.list.length ? true : false
          this.emptyShow = !this.list.length ? true : false
        } catch {
        } finally {
          this.loading = false
        }
      }
    },
    sortFn(list, type) {
      console.log(629,type)
      let t = type ? type : 'sort'
      let _a = '', _b = ''
      var arr = list.sort((a, b) => {
        if (type == 'time') {
          _a = a[t] ? moment(a[t]).toDate().getTime() : 0
          _b = b[t] ? moment(b[t]).toDate().getTime() : 0
        } else if (type == 'moneyScope') {
          _a =  a.declare && a.declare.money_scope_min ? a.declare.money_scope_min : 0
          _b =  b.declare && b.declare.money_scope_min ? b.declare.money_scope_min : 0
        } else {
          _a = a[t]
          _b = b[t]
        }
        return _b - _a
      })
      return arr
    },
    getMoneyScope(money_scope_max,money_scope_min){
      let moneyScopeMin = money_scope_min ? parseInt(money_scope_min/10000) : 0
      let moneyScopeMax = money_scope_max ? parseInt(money_scope_max/10000) : 0
      let moneyScope = ''
      if (moneyScopeMin == moneyScopeMax) {
        moneyScope = moneyScopeMin
       }else{
        moneyScope = moneyScopeMin + '-' + moneyScopeMax
      }
      return moneyScope
    },
    getNum(str){
      let num = 0
      if(str){
        // num = parseFloat(str*100)
        num = parseInt(parseFloat(str*100))
      }
      return num
    },
    getText(str) {
      let words = str.replace(/<[^<>]+>/g, "").replace(/&nbsp;/gi, ""); //这里是去除标签
      return words.replace(/\s/g, "") //这里是去除空格
    },
    declare(item) {
      this.declareInfo = item
      this.declareShow = true
    },
    declareAll() {
      this.declareInfo = this.list[0]
      this.declareShow = true
    },
    declareSelected(arg) {
      // this.declareShow = false
      // this.formCompany.name = arg.name
      // let query = {
      //   type: 'getPhone',
      //   declare_id: this.declareInfo.declare_id,
      //   serviceProviderId: arg.id
      // }
      // clickUrlToPhone('', query)
      this.declareShow = false;
      this.serviceInfo = {
        provider_name: arg.name,
        provider_id: arg.id,
        company_name: this.userInfo.company.name,
        phone: this.userInfo.phone,
        declare_id: this.declareInfo.id,
        user_name: this.userInfo.name,
        type: '政策申报'
      };
      this.showDialog = true;
    },
    closeDeclare() {
      this.declareShow = false
      this.formCompany.name = ''
    },
    async getCompany() {
      let res = await queryUserById({ userId: getUserInfo() ? JSON.parse(getUserInfo()).userId : '' })
      this.company = res.data || {}
    },
    async clickFavorite(val){
      console.log(val)
      console.log(val.favorite_num)
      let type = !val.favoriteValue
      console.log(type);
      const request = type ? addFavoritev3 : cancelFavoritev3
      let params = {article_id:val.id}
      let res = await request(params)
      this.$toast.success({ message: type ? '收藏成功' : '取消收藏成功', duration: 2000 })
      setTimeout(() => {
               val.favoriteValue=!val.favoriteValue
            if( val.favoriteValue){
                val.favorite_num= val.favorite_num+1
            }else{
                val.favorite_num-=1
            }
      }, 2000)
    },
    toVip() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      clickUrl('/vip')
    },
    goSearch() {
      if (goCodeFirm(this.userInfo)) {
        return false
      }
      clickUrl('/enterprise_match')
    },
    toggleItemLevel(val) {
      this.levelList = this.levelList.map((item) => {
        return {
          ...item,
          checked: item.id == val.id ? !item.checked : false,
        };
      });
    },
    goDetailFoMatch() {
      scrollTo(0, 650);
      return
      if (!this.list.length) {
        return false
      }
      var item = this.list[0]
      clickUrl('/article/detail', { id: item.declare_id,articleId:item.id, btnType: '1',matchingDegree: item.matchingDegree ,matchType:1,declare_id: item.declare_id})
    },
    //排序
    showPopupSort() {
      this.sortList = this.sortList.map((item) => {
        return {
          ...item,
          checked: item.id == this.formSearch.sort ? true : false,
        };
      });
      this.showSort = true
    },
    toggleItemSort(val) {
      this.sortList = this.sortList.map((item) => {
        return {
          ...item,
          checked: item.id == val.id ? !item.checked : false,
        };
      });
    },
    roundbtnSort() {
      var arr = this.sortList.filter(o=> o.checked)
      var sort = arr.length ? arr[0].id : 'sort'
      this.formSearch.sort = sort
      var list = this.sortFn(this.list, sort)
      console.log(735,list)
      this.showSort = false
    },
    /**
     * 申报v3开始
     */
    async beforeClose(action, done) {
      var that = this;
      if (action === "confirm") {
        // 点击确定走这里
        that.confirmService(function () {
          that.showDialog = false;
          that.$toast.success({ message: "提交成功" });
          that.checkXcx();
        });
      } else {
        // 点击取消走这里
        this.showDialog = false;
      }
    },
    async confirmService(callback) {
      let params = Object.assign({}, this.serviceInfo);
      try {
        let res = await savePhoneAndCompanyName(params);
        this.orderInfo = res.result;
        if (callback) {
          callback();
        }
      } catch {}
    },
    checkXcx() {
      var u = navigator.userAgent;
      if (u.indexOf("miniProgram") !== -1) {
        //在小程序里
        return false;
      }
      // 在微信网页
      this.$router.replace({
        path: "/order/detail",
        query: { id: this.orderInfo },
      });
    },
    /**
     * 申报v3结束
     */
    /**
     * 切换tab
     */
    changeTabs(val) {
      if (this.loading) {
        return false
      }
      this.activeTabs = val.name
       this.reset(1)
      this.getData()
    },
    reset(type) {
      if (type) {
        this.formSearch = {
          keywords: '',
          dispatch_name: '',
          level: '',//发文级别
          sort: '',
        }
      
        this.levelList = this.levelList.map((item) => {
          return {
            ...item,
            checked: false,
          };
        });
        this.fieldList = []
      }
      // this.clickSearch = false;
      this.list = [];
      this.totalList = 0
      this.finished = false
      this.emptyShow = false
    },
  },
  beforeRouteEnter(to, from, next) {
    // 进来的时候添加缓存组件 name
    // 此时不能使用this.$store.commit 因为组件还没有被创建所以不能使用this
    store.commit('ADD_KEEP_ALIVE_COM', 'EnterpriseMatch');
    next();
  },
  beforeRouteLeave(to, from, next) {
    // 离开的时候，非以下页面则删除缓存组件 name
    // 记录路由处的name值 (去往详情展示页面需要添加缓存)
    let coms = ['ArticleDetail'];
    console.log(coms.indexOf(to.name) === -1, to.name);
    if (coms.indexOf(to.name) === -1) {
      store.commit('REMOVE_KEEP_ALIVE_COM', 'EnterpriseMatch');
    }
    next();
  }
}

</script>
<style lang="scss" scoped>
.content-bg{
  .img{
    top:-120px;
  }
}
.policy-file-item {
  position: relative;
  & {
    margin: 10px;
    background: #fff;
  }

  &-content {
    padding: 15px;
  }

  &-title {
    font-weight: bold;
    margin-bottom: 8px;
  }

  &-tags {
    display: flex;
    flex-wrap: wrap;
  }

  &-tags>* {
    margin-bottom: 8px;
  }

  &-footer {
    display: flex;
    justify-content: space-between;
    border-top: 1px solid #eee;
    padding: 8px 15px;
    color: #aaa;
  }

  &-footer>view {
    font-size: 12px;
  }
}

.btn-boxs {
  width: 73px;
  height: 30px;
  margin-left: 12px;
  .btn-favorite {
    width: 100%;
    height: 30px;
    line-height: 35px;
    background: #24caa4;
    border: 1px solid transparent;
    color: #fff;
    border-radius: 30px;
    padding: 0 !important;
    text-align: center;
    .icon-favorite {
      height: 15px;
      background-size: cover;
      vertical-align: middle;
      margin-top: -4px;
    }
    &-active {
      background: linear-gradient(90deg, #ff7019 0%, #fe8f1a 100%);
    }
    &-dis{
        background: rgba(85, 138, 126, 0.2);
    }
  }
  .van-button--primary {
    width: 73px;
    background: #1989FA;
    border-radius: 14px 14px 14px 14px;
    border: none;
    opacity: 1;
    font-size: 12px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
}

.grid-box {
  display: flex;
  flex-wrap: wrap;
  padding: 12px 15px;
  background: #fff;
  box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.25);
  border-radius: 20px;

  .grid-item {
    position: relative;
    box-sizing: border-box;
    flex-basis: 33%;

  }

  .grid-item-content {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    height: 100%;
    justify-content: space-between;
    &.grid-item-content-d{
      text-align: left;
    }
    &.grid-item-content-l{
      text-align: center;
    }
    &.grid-item-content-r{
      text-align: right;
    }
    .grid-item-content-title {
      color: #000;
      margin-bottom: 5px;

      .nav-img {
        vertical-align: middle;
        width: 16px;
        height: 16px;
        background-size: cover;
      }
    }

    .grid-name {
      color: #B3B3B3;
    }
  }
}

.match-quick-box {
  padding: 10px 0;
  margin-bottom: 20px;
  background: #FFFFFF;
  box-shadow: 0px 4px 8px 1px rgba(47, 106, 146, 0.25);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  width:49%;
  
  .match-quick-title {
    padding-left: 10px;
    font-size: 16px;
    font-family: 'PingFang SC-Medium, PingFang SC';
    font-weight: 600;
    color: #000;
    /* margin: 0 16px; */
    &:before {
    content: "";
    margin-right: 5px;
    border-left: 3px solid #1989FA;
}
  }
  .match-quick-txt {
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;
      font-weight: 400;
      color: #5FA9FD;
      line-height: 16px;
      margin-left: 14px;
  }

  .match-quick-name {
    color: #5FA9FD;
    margin: 8px 16px;
  }

  .match-quick-content {
    margin: 0 8px;
    height: 88px;
    background: url('../../assets/images/match/bg_2@2x.png') no-repeat center center;
    background-size: cover;
    border-radius: 6px;

    .match-quick-content-d {
      padding: 5px 10px;
      color: #fff;
      font-size: 14px;
      font-family: PingFang SC-Regular, PingFang SC;

      .num {
        font-size: 18px;
        font-family: PingFang TC-Semibold, PingFang TC;
        font-weight: 600;
        line-height: 33px;
        margin: 10px 0;
      }
    }
  }
  .match-quick-content1 {
    padding-top: 5px;
    box-sizing: border-box;
     margin: 0 8px;
    height: 88px;
    background: url('../../assets/images/match/bg_2@2x.png') no-repeat center center;
    background-size: cover;
    border-radius: 6px;
    font-size: 12px;
    font-family: PingFang SC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 14px;
     div {
      margin: 3px  2.5px;
      white-space: nowrap; 
      overflow: hidden;
      text-overflow: ellipsis;
       
     }
     
  }
    .morebtn  {
                font-weight: 400;
                color: rgba(0, 0, 0, 0.6);
     }
}

.van-list {
  background: #fff;
  padding: 12px 16px;

  .policy-file-item {
    box-shadow: 0px 2px 8px 1px rgba(0, 0, 0, 0.15);
    border-radius: 8px;
    margin: 12px 0;

    .level {
      padding: 3px;
      background: #1989FA;
      color: #fff;
      border-radius: 4px;
      font-weight: 400;
    }

    .tag {
      padding: 0 3px;
      color: #000;
      border-radius: 4px;
      font-weight: 400;
      margin-right: 5px;

      &.tag_0 {
        background: #D8F4F0;
        border: 1px solid #33978B;
      }

      &.tag_1 {
        background: rgba(139, 184, 213, 0.35);
        border: 1px solid #8BB8D5;
      }
    }
  }
}

.policy-file-item-result {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
  color: #000;
  line-height: 15px;

  .result-b {
    color: #555;
  }

  .num-r {
    font-size: 24px;
    font-weight: 600;
  }

  .num-p {
    font-size: 18px;
    font-weight: 600;
  }
}

.color-1 {
  color: #FF642E;
}

.btn-de{
  border-radius: 4px;
  width: 65px;
  margin-top: 10px;
}
.favorite{
  font-size: 12px;
  color: #000;
}
.float-action{
    padding: 5px 50px;
    .btn{
      background: linear-gradient(129deg, #1091E8 0%, #1A6FE0 100%);
      img{
        width: 20px;
        height:19px;
        background-size: cover;
        vertical-align: middle;
        margin-right: 6px;
      }
    }
}
.content-bg .avatar-box .vip_no_flag_box {
  background: url('../../assets/images/match/bg_vip@2x.png') no-repeat center center;
  background-size: contain;
}
.tag-reg-type {
  width: 100px;
  div{
  white-space:nowrap;
  overflow:hidden;
  text-overflow:ellipsis;
  }
}

.coupon-ad-box{
  margin: 0 10px 25px;
}

.notice-item-novip {
  filter: blur(4px);
  .notice-item-title{
    color: rgba(0, 0, 0, 0.2);
  }
  position: relative;
}
.novip-box{
    position: absolute;
z-index:10;
display: flex;
align-items: center;
text-align: center;
top:0;
left:0;
width:100%;
height: 100%;
font-size: 12px;
color: #666;
.flex-item{
    flex: 1;
    .btn{
    width: 105px;
    height:35px !important;
    line-height: 30px;
    background: linear-gradient(180deg, #FFF4E0 0%, #FBCB89 100%);
    box-shadow: 0px 4px 4px 1px rgba(180, 164, 123, 0.25);
    border-radius: 20px;
    border: 0;
    font-size: 12px;
    font-weight: 600;
    color: #FF5019;
    white-space: nowrap;
    margin-top:5px;

    }
}
}
.declare-btn {
  margin-top: 10px;
}
.update-box{
  font-size: 12px;
  color: #fff;
  line-height: 22px;
  margin-top:3px;
  .btn-update{
    width:120px;
    height: 22px !important;
    padding: 0 !important;
    border: 0;
    background: linear-gradient(180deg, #7DBEFF 0%, #1989FA 100%);
    box-shadow: 0px 4px 4px 1px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    color: #fff;
    margin-right: 5px;
    vertical-align: middle;
  }
}
.color_1{
  color: #fff;
}
.tag-item{
  display: inline-block;
  margin: 5px;
}
.favorite .van-switch{
  border: 0;
  vertical-align: middle;
}
.favorite .van-switch__node{
  background: #FB8729;
}
.favorite .van-switch--on .van-switch__node{
  background: #FFAC68;
}
.van-search__action {
  width: 50px;
  text-align: center;
  color: #fff;
  background: #1989FA;
border-radius: 14px 14px 14px 14px;
opacity: 1;
}
.serch {
  background-color: #fff;
  text-align: center;
  display: flex;
  justify-content: space-around;
 
}
 .serch-item{
    color: #35B2F2;
    position: relative;
    padding: 8px;
&:after {
    position: absolute;
    top: 50%;
    right: -4px;
    margin-top: -5px;
    border: 3px solid;
    border-color: transparent transparent currentColor currentColor;
    transform: rotate(-45deg);
    opacity: .8;
    content: "";
}

&-active:after {
    margin-top: -1px;
    transform: rotate(135deg);
}
  }
  .field-ul {
      margin: 0 20px;
      display: flex;
      flex-wrap: wrap;
  }
  .flex-tag-select-container {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 10px;
        box-sizing: border-box;
        z-index: 10;
        /* overflow: auto; */
    }
    .title {
      font-size: 14px;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #000000;
      line-height: 16px;
      text-align: center;
      background-color: #F2F2F2;
      margin-top: 0px;
      height: 30px;
      line-height: 30px;
    }
     .flex-tag-select-item {
      display: flex;
        justify-content: center;
        align-items: center;
        color: #000;
        min-height:30px;
        border: 1px solid #fff;
        box-sizing: border-box;
        background: rgba(231, 231, 231, 0.4);
        border-radius: 4px;
    }
    .flex-tag-select-item.selected {
        border: 1px solid #1989FA;
        color: #fff;
        background: #1989FA;
    }
    .roundbtn{
      height: 40px !important;
      background-color: #02A7F0;
      color: #fff;
      width: 100%;
    }

    .match-container-search {
    height: 42px;
background: #F0FAFF;
    border-radius: 26px;
    display: flex;
    position: relative;
    display: flex;
    flex-direction: row;
    border: 1px solid #35B2F2;
    margin: 0 28px;

    input {
      flex: 1;
      height: 36px;
      border-top-left-radius: 26px;
      border-bottom-left-radius: 26px;
      border: 0;
      box-sizing: border-box;
      padding: 0 8px 0 30px;
      font-size: 12px;
      background: #F0FAFF;
      margin: 4px 0;

      &::placeholder {
        color: #808080;
      }
    }

    .btn {
      width: 60px;
      height: 36px;
      background: linear-gradient(304deg, #0070FF 0%, #2CC7F8 100%);   
      opacity: 0.8;
      border-radius: 26px;
      border: 1px solid rgba(255, 255, 255, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      margin: auto 3px auto 7px;

      img {
        width: 27px;
        background-size: contain;
      }
    }
  }

  .service-box {
  .title {
    height: 42px;
    line-height: 42px;
    background: linear-gradient(360deg, #18a0ff 0%, #0bc6fc 100%);
    font-size: 18px;
    font-weight: 500;
    color: #fff;
    text-align: center;
  }
  .content {
    padding: 20px 13px;
    .box {
      border-top: 1px solid #f7f7f7;
      &:first-child {
        margin-bottom: 20px;
      }
      .flex {
        font-size: 12px;
        font-weight: 400;
        color: #999;
        border-bottom: 1px solid #f7f7f7;
        padding: 6px 0;
        .label {
          width: 83px;
          color: #666;
          text-align: center;
          border-right: 1px solid #f7f7f7;
          margin-right: 10px;
        }
      }
    }
  }
}
.head-title {
  font-size: 18px;
font-family: PingFang SC-Medium, PingFang SC;
font-weight: 500;
color: #FFFFFF;
line-height: 21px;
text-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);

}
.match-box {
width: 100%;
// height: 300px;
margin-bottom: 20px;
// background: linear-gradient(304deg, #8DCBF2 0%, #9EB2EB 100%);
background: linear-gradient(180deg, #FFFFFF 0%, rgba(255,255,255,0) 100%);
border-radius: 8px;
opacity: 1;
padding: 8px;
box-sizing: border-box;
  .match-head{
    display:flex;
    .match-quick-title {
      width: 50%;
    padding-left: 10px;
    font-size: 16px;
    font-family: 'PingFang SC-Medium, PingFang SC';
    font-weight: 600;
    color: #000;
    text-align: left;
    /* margin: 0 16px; */
    &:before {
      content: "";
      margin-right: 5px;
      width: 3px;
      height: 65%;
      background: #1989FA;
      display: inline-block;
      position: relative;
      top: 10%;
    }
  }
  }
  .match-quick-box{
    height: auto;
    width:90%;
    padding: 5px;
    background: #FDFDFD;
    box-shadow: 0px 0px 4px 0px rgba(90,162,199,0.25);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    margin-top: 5px;
    margin-bottom: 0px;
      .match-quick-box-head {
          font-size: 12px;
          font-family: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #424242;
          line-height: 14px;
          margin-bottom: 5px;
      }
      .match-quick-box-num {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.6);
        line-height: 14px;
         margin-bottom: 5px;
      }
      .match-quick-box-text {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #1391E9;
        line-height: 14px;
         margin-bottom: 5px;
      }
      .num {
          font-size: 16px;
          font-family: PingFang TC-Semibold, PingFang TC;
          font-weight: 600;
          color: #FF7319;
          line-height: 18px;
      }
      .match-quick-box-icon1{
        width: 9px;
        height: 9px;
        background: linear-gradient(90deg, #1391E9 0%, #13B6E9 100%);
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        margin-right: 4px;
        margin-top: 4px;
      }
      .match-quick-box-icon2{
        width: 37px;
        height: 9px;
        background: linear-gradient(90deg, #1391E9 0%, #13B6E9 100%);
        border-radius: 5px 5px 5px 5px;
        opacity: 1;
        margin-right: 40px;
        margin-top: 4px;
      }
      .match-quick-box-icon3{
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #1391E9;
        line-height: 14px;
      }
  }
  .match-quick-box1{
    margin-top: 5px;
    padding:0px 5px;
    box-sizing: border-box;
    height: 252px;
    background: #FDFDFD;
    box-shadow: 0px 0px 4px 0px rgba(90,162,199,0.25);
    border-radius: 8px 8px 8px 8px;
    opacity: 1;
    width: 90%;
      .match-quick-txt{
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0,0,0,0.6);
        line-height: 14px;
        margin-bottom: 5px;
        margin-top: 5px;
      }
      .match-quick-content1 {
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #232323;
        line-height: 14px;
        div {
          margin-bottom: 5px;
        }
      }
       .match-quick-box-icon3{
        margin-top: 5px;
        font-size: 12px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #1391E9;
        line-height: 14px;
        margin-left: 10px;
      }
      .lxcx-more{
        .match-quick-box-icon3{
           margin-left: 0;
        }
        .img-box{
          width:89px;
          .img{
            width:100%;
            background-size: contain;
          }
        }
      }
      
  }
}
.num_total {
  font-size: 18px;
  font-family: PingFang TC-Semibold, PingFang TC;
  font-weight: 600;
  color: #FF7319;
  line-height: 21px;
}
</style>
